module.exports = "<div class=\"aside\" id=\"updateShipping\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-update-shipping/template.html
// module id = ./pages/xo-sidebar-update-shipping/template.html
// module chunks = 1